<template>
  <el-popover v-bind="$attrs" v-on="$listeners"><slot /><slot slot="reference" name="reference" /></el-popover>
</template>

<script>
export default {
  name: 'RtPopover',
}
</script>


// WEBPACK FOOTER //
// rtPopover.vue?d462c8a2